import { html } from '@shared/utils/rendering/html';

export const HistoryDetailItem = ({ label, value, css }) => {
    return html`
        <div class="detail-item">
            <label class="detail-label">${label}</label>
            <div class="detail-value ${css ?? ''}">${value}</div>
        </div>
    `;
};
